import { useDispatch } from 'react-redux';

import { CustomAlert, CustomButton, Text } from '../../../shared/uiComponents';
import { ChevronRight, Plus } from '../../../shared/Assets/svgIcons';
import '../calendar.scss';
import { DispatchProperties, useSelector } from '../../../redux/store';
import {
	setAddInstantSession,
	setAddScheduledSession,
	setAddSession,
} from '../../../redux/State/clientSlice/calendarHelperSlice';
import { AdminTypes } from '../../../components/Menu';
import { Play, Schedule } from '../../../shared/Assets/sessionDetailsSVGs';
import { useScreenWidth } from '../../../shared/Helpers/hooks';
import { BACKGROUND } from '../../../shared/Helpers/colors';

const Content = () => {
	const dispatch = useDispatch<DispatchProperties>();

	const closeAddSessionHandler = () => dispatch(setAddSession(false));

	const instantSessionHandler = () => {
		dispatch(setAddInstantSession(true));
		closeAddSessionHandler();
	};

	const scheduledSessionHandler = () => {
		dispatch(setAddScheduledSession(true));
		closeAddSessionHandler();
	};

	return (
		<div className="addSessionContent">
			<div className="addSessionAction">
				<div className="icon">
					<Play />
				</div>
				<Text title="Start an instant session" fontWeight="semiBold" className="text" />
				<CustomButton
					buttonType="quaternary"
					iconOnly={<ChevronRight />}
					style={{ borderRadius: '999px', padding: '8px' }}
					onClick={instantSessionHandler}
				/>
			</div>
			<div className="addSessionAction">
				<div className="icon">
					<Schedule />
				</div>
				<Text title="Schedule on calendar" fontWeight="semiBold" className="text" />
				<CustomButton
					buttonType="quaternary"
					iconOnly={<ChevronRight />}
					style={{ borderRadius: '999px', padding: '8px' }}
					onClick={scheduledSessionHandler}
				/>
			</div>
		</div>
	);
};

const AddSession = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const screenWidth = useScreenWidth();
	const isMobile = screenWidth < 768;

	const open = useSelector((state) => state.calendarHelper.popups.add);
	const role = useSelector((state) => state.account.role);
	const isAdmin = role?.section.id === AdminTypes.admin;

	const openAddSessionHandler = () => dispatch(setAddSession(true));
	const closeAddSessionHandler = () => dispatch(setAddSession(false));

	const scheduledSessionHandler = () => dispatch(setAddScheduledSession(true));

	return (
		<>
			<CustomButton
				title="New Session"
				onClick={isAdmin ? scheduledSessionHandler : openAddSessionHandler}
				className="newSessionButton"
				iconOnly={isMobile && <Plus color={BACKGROUND.PRIMARY[100]} />}
				aria-label="New Session"
			/>
			<CustomAlert
				title="Add session"
				titleOnTop={false}
				open={open}
				onClose={closeAddSessionHandler}
				Content={Content}
			/>
		</>
	);
};

export default AddSession;
